import React, { useContext, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "./context/UserContextProvider";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";

// Pages
import Dashboard from "./pages/Dashboard";
import UserManagement from "./pages/UserManagement";
import TestRunManagement from "./pages/TestRunManagement";
import MasterTestFolder from "./pages/MasterTestFolder";
import Profile from "./pages/ProfilePage";
import ChangePassword from "./pages/ChangePassword";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CheckEmail from "./pages/CheckEmail";
import TestRunView from "./pages/TestRunView";
import TestCaseView from "./pages/TestCaseView";


// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(UserContext);

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Public Route wrapper (redirect if already authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(UserContext);

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

const AppRouter = () => {
  const { checkAuth } = useContext(UserContext);
  
  useEffect(() => {
    checkAuth();
    document.title = "V-Automate";
  }, []);

  return (
    <Routes>
      {/* Public routes - only accessible when NOT logged in */}
      <Route path="/" element={
        <PublicRoute>
          <AuthLayout />
        </PublicRoute>
      }>
        <Route index element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="check-email" element={<CheckEmail />} />
      </Route>

      {/* Protected routes - only accessible when logged in */}
      <Route path="/admin/*" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="user-management" element={<UserManagement />} />
        <Route path="test-run-management" element={<TestRunManagement />} />
        <Route path="master-test-folder" element={<MasterTestFolder />} />
        <Route path="profile" element={<Profile />} /> 
        <Route path="change-password" element={<ChangePassword />} /> 
        <Route path="test-run-view/:runId" element={<TestRunView />} />
        <Route path="test-case-view/:folderId" element={<TestCaseView />} />
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouter;